"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.withOnDemandTranslationProps = withOnDemandTranslationProps;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _OnDemandTranslationContext = require("./OnDemandTranslationContext");

// HOC that consumes the TranslationContext and passes selected props to the wrapped component
function withOnDemandTranslationProps(WrappedComponent) {
  var selectProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return function WithOnDemandTranslationPropsComponent(props) {
    return (0, _preact.h)(_OnDemandTranslationContext.OnDemandTranslationContext.Consumer, null, function (context) {
      // Filter context to only include selected props
      var filteredContext = {};

      if (selectProps.length === 0) {
        // If no specific props selected, include all context
        Object.assign(filteredContext, context);
      } else {
        // Otherwise only include selected props
        selectProps.forEach(function (key) {
          // @ts-expect-error - TS doesn't like this, but it's fine
          filteredContext[key] = context[key];
        });
      } // @ts-expect-error - TS doesn't like this, but it's fine


      return (0, _preact.h)(WrappedComponent, (0, _extends2.default)({}, props, filteredContext));
    });
  };
}

var _default = withOnDemandTranslationProps;
exports.default = _default;